import React from 'react';
import MUITable, {
  TableBody,
  TableCell,
  TableFooter,
  TablePagination,
  TableRow,
} from 'material-ui-next/Table';
import {
  TablePaginationActions,
  EnhancedTableHead
} from '../../widgets/table_utils.react.js';
import Checkbox from 'material-ui-next/Checkbox';
import {
  Redirect
} from 'react-router-dom'
import CSSModules from 'react-css-modules';
import Chip from 'material-ui-next/Chip';
import styles from './all.css';
import Avatar from 'material-ui-next/Avatar';
import Tooltip from 'material-ui-next/Tooltip';
import AdminIcon from '../../assets/icons/adminIcon.react.js';
import AccVerifiedIcon from '../../assets/icons/accountVerifiedIcon.react.js';
import OEMIcon from '../../assets/icons/oemIcon.react.js';

class AdminUserTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      redirect: null,
      all_data: props.data,
      data: [],
      enableSelect: false,
      order: 'asc',
      orderBy: 'username',
      selected: [],
      page: 0,
      new_page: 0,
      rowsPerPage: 10,
      rowCount: 0,
      loading: false,
    }

    this.on_load_data = this.on_load_data.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.refresh = this.refresh.bind(this)
    this.handleResend = this.handleResend.bind(this)

    this.handleRequestSort = this.handleRequestSort.bind(this)
    this.handleSelectAllClick = this.handleSelectAllClick.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleChangePage = this.handleChangePage.bind(this)
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
    this.isSelected = this.isSelected.bind(this)
    this.sortData = this.sortData.bind(this)

    this.get_column_configs = this.get_column_configs.bind(this)
  }

  get_column_configs(return_dict) {
    const columnConfigs = [
      {
        id: 'username',
        numeric: false,
        disablePadding: false,
        label: 'Email',
        data: (raw) => {
          return raw.username
        }
      },
      {
        id: 'permissions',
        numeric: false,
        disablePadding: false,
        label: 'Permissions',
        disableSort: true
      },
      {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'Actions',
        disableSort: true
      }
    ]

    if (return_dict) {
      return columnConfigs.reduce((obj, item) => {
        obj[item.id] = item
        return obj
      }, {})
    }

    return columnConfigs
  }

  sortData(data, order, orderBy) {
    var self = this;

    const _data =
      order === 'desc' ?
      data.sort(
        (a, b) => {
          var va = a[orderBy]
          var vb = b[orderBy]
          const get_data = self.get_column_configs(true)[orderBy].data
          if (get_data) {
            va = get_data(a)
            vb = get_data(b)
          }
          return (vb < va) ? -1 : 1
        }
      ) :
      data.sort(
        (a, b) => {
          var va = a[orderBy]
          var vb = b[orderBy]
          const get_data = self.get_column_configs(true)[orderBy].data
          if (get_data) {
            va = get_data(a)
            vb = get_data(b)
          }
          return (va < vb) ? -1 : 1
        }
      );

    this.setState({
      order,
      orderBy,
      data: _data,
      loading: false
    });
  }

  handleRequestSort(event, property) {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.sortData(this.state.data, order, orderBy)
  }

  handleSelectAllClick(event, checked) {
    if (checked) {
      this.setState({
        selected: this.state.data.map(n => n.id)
      });
      return;
    }
    this.setState({
      selected: []
    });
  }

  handleClick(event, id) {
    const {
      selected
    } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({
      selected: newSelected
    })
  }

  handleChangePage(event, page) {
    this.setState({
      selected: [],
      data: this.state.all_data.slice(
        page * this.state.rowsPerPage,
        page * this.state.rowsPerPage + this.state.rowsPerPage
      ),
      page: page
    }, () => {
      /* this.refresh(
       *   page * this.state.rowsPerPage
       * )*/
      this.sortData(this.state.data, this.state.order, this.state.orderBy)
    });
  }

  handleChangeRowsPerPage(event) {
    const rowsPerPage = event.target.value;
    this.setState({
      rowsPerPage: rowsPerPage,
      selected: [],
      data: this.state.all_data.slice(
        this.state.page * rowsPerPage,
        this.state.page * rowsPerPage + rowsPerPage
      )
    }, () => {
      /* this.refresh(
       *   this.state.new_page * this.state.rowsPerPage,
       *   this.state.rowsPerPage
       * )*/
      this.sortData(this.state.data, this.state.order, this.state.orderBy)
    });
  }

  isSelected(id) {
    return this.state.selected.indexOf(id) !== -1
  }

  refresh(offset, rowsPerPage) {
    this.setState(
      {loading: true}, () => {
        this.props.load_data(
          rowsPerPage || this.state.rowsPerPage,
          offset || this.state.new_page * this.state.rowsPerPage,
          this.on_load_data
        )
      }
    )
  }

  on_load_data(all_users) {
    this.setState({
      all_data: all_users.users,
      rowCount: all_users.users.length,
      page: this.state.new_page
    }, () => {
      const data = this.state.all_data.slice(
        this.state.page * this.state.rowsPerPage,
        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
      )
      this.sortData(data, this.state.order, this.state.orderBy)
    })
  }

  componentWillMount() {
    this.refresh()
  }

  handleClickEdit(data) {
    var self = this;
    return (e) => {
      self.props.open_edit(data)
    }
  }

  handleResend(data) {
    var self = this;
    return (e) => {
      self.props.open_resend(data)
    }
  }

  handleDelete(data) {
    var self = this;
    return (e) => {
      self.props.open_delete(data)
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={{pathname: this.state.redirect}} />
    }
    const columnConfigs = this.get_column_configs()
    const {
      loading,
      data,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      rowCount,
      enableSelect
    } = this.state;
    const emptyRows = rowsPerPage - data.length;
    return (
      <MUITable styleName="admin-table">
        <EnhancedTableHead
          loading={loading}
          enableSelect={enableSelect}
          numSelected={selected.length}
          onRequestSort={this.handleRequestSort}
          onSelectAllClick={this.handleSelectAllClick}
          order={order}
          orderBy={orderBy}
          rowCount={data.length}
          columnConfigs={columnConfigs}
        >
        </EnhancedTableHead>
        <TableBody>
          {
            this.state.data.map((info) => {
              const user = info
              const isSelected = this.isSelected(info.id);
              var actions = [
                (
                  <Chip
                    styleName="admin-table-action"
                    key="del"
                    label="Delete"
                    onClick={this.handleDelete(info)}
                  />
                )
              ]
              if (!user.verified) {
                actions.push(
                  <Chip
                    styleName="admin-table-action"
                    key="resend"
                    label="Resend Invite Link"
                    onClick={this.handleResend(info)}
                  />
                )
              }
              return (
                <TableRow key={info.id} aria-checked={isSelected} selected={isSelected}>
                  {enableSelect && (
                     <TableCell padding="checkbox">
                       <Checkbox checked={isSelected} />
                     </TableCell>
                  )}
                  <TableCell>
                      {user.username}
                  </TableCell>
                  <TableCell>
                    <div styleName="admin-table-icon-cell">
                      {user.verified && <Tooltip title="Verified User" placement="bottom">
                        <Avatar>
                          <AccVerifiedIcon />
                        </Avatar>
                      </Tooltip>}
                      {user.admin && <Tooltip title="Admin" placement="bottom">
                        <Avatar>
                          <AdminIcon />
                        </Avatar>
                      </Tooltip>}
                      {user.oem && <Tooltip title="Manufacturer" placement="bottom">
                        <Avatar>
                          <OEMIcon />
                        </Avatar>
                      </Tooltip>}
                    </div>
                  </TableCell>
                  <TableCell>
                    <div>
                      {actions}
                    </div>
                  </TableCell>
                </TableRow>
              )
            })
          }
          {emptyRows > 0 && (
             <TableRow>
               <TableCell colSpan={6} />
             </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={10}
              count={rowCount}
              rowsPerPageOptions={[10, 25, 50]}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
              Actions={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </MUITable>
    )
  }
}

AdminUserTable.defaultProps = {
  data: [],
  load_data: null,
  delete_item: null,
  open_edit: null,
  open_delete: null
}

export default CSSModules(AdminUserTable, styles)



// WEBPACK FOOTER //
// ./src/views/admin/user_table.react.js